module.exports = __webpack_public_path__ + "img/earn-count-bg.7bae9787.jpg";